import { Suspense, useRef, useState } from "react";
import { useEffect } from "react";
import { getGroups, listSitesWithLiveView } from '../../Api Methods/Api'
import { useDispatch, useSelector } from "react-redux";
import classes from './liveViewSites.module.css'
import Modal from "../../components/Modal/Modal";
import ListCard from "../../components/GridList/ListCard";
import Oval from "react-loading-icons/dist/esm/components/oval";
import { Dropdown } from "primereact/dropdown";
import { Await, Link, useNavigate } from "react-router-dom";
import Pill_Widget from "../../components/UI/Widgets/Pill_Widget";
import useSetCookie from "../../components/hooks/UseSetCookie";
import OutputPinCircle from "../../components/UI/DataLayouts/OutputPinCircle";
import InputPinCircle from "../../components/UI/DataLayouts/InputPinCircle";
import BasicTable from "../../components/Table/Table/Table";
import StatCard from "../../components/UI/Stats/StatCard";
import DeviceLoadingGrid from "../../components/GridList/DeviceLoadingGrid";
import { Button } from "primereact/button";
import { format } from "date-fns";
import { serviceActions } from "../../store/service-Slice";
import DataManager from "../../hooks/DataManager";
import DevicesList from "../../components/GridList/DevicesList";
import { off } from "rsuite/esm/DOMHelper";
import mixpanel from "mixpanel-browser";
import CameraTableLayout from "../../components/Table/CameraTableLayout";
import LiveViewSitesSearchBar from "./liveviewSitesSearchBar";
import LiveViewCamerasSearchBar from "./liveviewCamerasSearchBar";

const LiveViewSites = () => {

    const cachedSites = useSelector(state => state.service.LiveViewTableData);
    const [sites, setSites] = useState(cachedSites);
    const [cameras, setCameras] = useState([])
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    localStorage.removeItem('DeviceUUID')
    const apiData = {
        token,
        client
    }
    const ModalDialog = useRef();
    const [modalTitle, setModalTitle] = useState("title")
    const [modalComponent, setModalComponent] = useState()
    const loggedInAs = useSelector(state => state.auth.companyName);

    const [groups, setGroups] = useState([])
    const [groupNames, setGroupNames] = useState([])
    
    const dataManager = new DataManager();

    const [siteCount, setSiteCount] = useState(0)
    const [cameraCount, setCameraCount] = useState(0)
    const [totalCameraCount, setTotalCameraCount] = useState(0)
    const [isLoading, setIsLoading] = useState(() => {
      return !cachedSites || cachedSites.length === 0;
    });    
    const [isLoadingStats, setIsLoadingStats] = useState(true);  
    const [online, setOnline] = useState(0)
    const [offline, setOffline] = useState(0)
    const [deviceTag, setDeviceTag] = useState(null)
    const [deviceType, setDeviceType] = useState(0)
    const [groupName, setGroupName] = useState(null)
    const [noTag, setNoTag] = useState(0)

    const [visibleDevices, setVisibleDevices] = useState([]);
    const [page, setPage] = useState(0)

    const [totalPages, setTotalPages] = useState([])
    const [resultCount, setResultCount] = useState(0)
    const [totalDevices, setTotalDevices] = useState([])
    const [pageFetchedIndex, setPageFetchedIndex] = useState(1)
    const [pageSize, setPageSize] = useState(dataManager.getItem('pageSize'))
    const [update, setUpdate] = useState(0)
    const [showMassSettings, setShowMassSettings] = useState(false)
    const [linkedOnly, setLinkedOnly] = useState(false)
    const [pageOffset, setPageOffset] = useState(0)
    const [sitesWithCameraCount, setSitesWithCameraCount] = useState(0)
    const [activeTab, setActiveTab] = useState(0)
    const [searchQuery, setSearchQuery] = useState("")
    const [cameraSearchQuery, setCameraSearchQuery] = useState("")
    const [cameraTypeFilter, setCameraTypeFilter] = useState([])

    const GetGroups = async () => {
      const groups = await getGroups(apiData, dispatch)
      setGroups(groups)
      setGroupNames(groups.map(listOptions => listOptions.name))
    }
  
    useEffect(() => {
      setIsLoading(true)

      const offset = pageSize * (pageFetchedIndex -1);
      setPageOffset(offset);
  
      getLiveViewSites(offset); 
        // pass the computed value
      
  }, [pageSize, pageFetchedIndex, online, offline, deviceTag, groupName]);

  useEffect(() => {
    GetGroups();

    mixpanel.track("Live view enabled tab visited", {
      user: localStorage.getItem('email')
    });

  }, []);

    const getLiveViewSites = async (offset) => {
        const body = {
            "pageSize": pageSize,
            "pageOffset": offset,
            "online": online, 
            "offline": offline, 
            "deviceTag": deviceTag,
            "groupName": groupName,
            "hasCamerasLinked": 0
        }

        const response = await listSitesWithLiveView(apiData, body, dispatch)
        if (response.success){
          console.log(response);
            setSiteCount(response.data[0][0].liveViewEnabledCount)

            setCameraCount(response.data[0][0].withLinkedCamerasCount)

            // setTotalCameraCount(response.data[0][0].totalLinkedCameras)

            setSitesWithCameraCount(response.data[0][0].totalLinkedCameras)

            setSites(response.data[1])

            setCameras(response.data[2])
            console.log(response.data[2]);
            dispatch(serviceActions.setLiveViewEnabledTableData(response.data[1]));

            setTotalPages(Math.ceil(response.data[0][0].withLinkedCamerasCount / pageSize));
            setIsLoading(false)
            setIsLoadingStats(false)
        } else {
        }
    }

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();
        //setSelectedMassAction("")
    }

    const HandleUipiodOnClick = (DeviceUUID) => {
        dispatch(serviceActions.setDeviceUUID(DeviceUUID));
        useSetCookie("DeviceUUID", DeviceUUID, 1);
        navigate("/Dashboard/SiteView/" + DeviceUUID);
   }

    const HandleGroupOnClick = (groupName) => {
        const groupClicked = groups.find(g => g.name === groupName);
        if (groupClicked) {
            sessionStorage.setItem('groupClicked', groupClicked.name)   
            sessionStorage.setItem('groupPath', groupClicked.group_path)
            sessionStorage.setItem('groupClickedID', groupClicked.id)   
            navigate("/Dashboard/Groups/GroupSites")
        }
    }
  
    const HandleTotalSitesClicked = () => {

    }

    return (
      <Await resolve={sites}>
        {(loadedSites) => {
          return (
            <>
              <div style={{ width: "100%" }}>
                <div style={{ display: "flex", flexDirection: "row", gap: "12px", marginBottom: "16px", width: "100%" }}>
                  <StatCard title={"Total live view enabled sites"} value={siteCount} isLoading={isLoadingStats} />
                  <StatCard title={"With a camera linked"} value={cameraCount} isLoading={isLoadingStats} />
                  <StatCard title={"Total linked cameras"} value={sitesWithCameraCount} isLoading={isLoadingStats} />
                </div>

                <div className={classes.tabsWrapper}>
                  <div className={classes.tabs}>
                    {["Sites", "Cameras"].map((tab, i) => (
                      <button
                        key={tab}
                        className={`${classes.tab} ${activeTab === i ? classes.active : ""}`}
                        onClick={() => setActiveTab(i)}
                      >
                        {tab}
                      </button>
                    ))}
                  </div>

                  <div className={classes.tabContent}>
                    {activeTab === 0 && (
                      isLoading ? (
                        <div style={{ display: "flex", width: "100%" }}>
                          <DeviceLoadingGrid CardCount={20} />
                        </div>
                      ) : (
                        <>
                        <LiveViewSitesSearchBar
                          placeholder="Search sites..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          groups={groups}
                          groupName={groupName}
                          setGroupName={setGroupName}
                          excelData={sites?.map(s => ({ 'Site ID': s.key, 'Portal Name': s.tag, 'Group': s.name }))}
                          fileName="Live View Sites"
                        />
                        <DevicesList
                          devices={sites}
                          filtering={searchQuery}
                          hideControls={false}
                          totalPages={totalPages}
                          setTotalPages={setTotalPages}
                          pageFetchedIndex={pageFetchedIndex}
                          setPageFetchedIndex={setPageFetchedIndex}
                          pageSize={pageSize}
                          setPageSize={setPageSize}
                          totalDevices={siteCount}
                          setTotalDevices={setTotalDevices}
                          groupMode={false}
                          update={update}
                          setUpdate={setUpdate}
                          offlineOnly={false}
                          isSortable={true}
                          showMassSelect={true}
                          showMassSettings={showMassSettings}
                          setShowMassSettings={setShowMassSettings}
                          liveViewOnly={true}
                          isLiveViewSites={true}
                        />
                        </>
                      )
                    )}

                    {activeTab === 1 && (
                      <>
                        <LiveViewCamerasSearchBar
                          placeholder="Search cameras..."
                          value={cameraSearchQuery}
                          onChange={(e) => setCameraSearchQuery(e.target.value)}
                          cameraTypeFilter={cameraTypeFilter}
                          setCameraTypeFilter={setCameraTypeFilter}
                          excelData={cameras?.filter(c => cameraTypeFilter.length === 0 || cameraTypeFilter.includes(c.type)).map(c => ({ 'Camera Name': c.name, 'Type': c.type, 'Site ID': c.key, 'Portal Name': c.tag, 'Group': c.groupName }))}
                          fileName="Live View Cameras"
                        />
                        <CameraTableLayout
                          data={cameraTypeFilter.length > 0 ? cameras?.filter(c => cameraTypeFilter.includes(c.type)) : cameras}
                          isloading={isLoading}
                          groups={groups}
                          filtering={cameraSearchQuery}
                          apiData={apiData}
                          onRefresh={() => getLiveViewSites(pageOffset)}
                        />
                      </>
                    )}
                  </div>
                </div>
              </div>
            </>
          )
        }}
      </Await>
    )
}

export default LiveViewSites;